var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoWithBackground = function SvgVideoWithBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.664 15.535a.71.71 0 0 0-.693-.033l-4.682 2.344V16.14A2.14 2.14 0 0 0 22.176 14H12.14A2.14 2.14 0 0 0 10 16.14v8.578a2.14 2.14 0 0 0 2.14 2.14h10.003a2.146 2.146 0 0 0 2.146-2.14v-1.7l4.676 2.338a.721.721 0 0 0 .963-.319c.05-.1.075-.212.072-.325V16.14a.693.693 0 0 0-.336-.605Z",
    fill: "#6F6F6F"
  })));
};
export default SvgVideoWithBackground;